import actions from "redux-form/lib/actions";

const initialState = {
	"objetoSReparacion": {},
	"sreparacion": {},
	"originalReembolsos":[],
	"sreembolsos": [],
	"sinrepSelect": {},
	"detalleSiniestro": [],
	"sinremSelect":{},
	"aviso": false,
	"reparacion": {},
	"pagos": [],
	"robos": {},
	"pt": {},
	"siniestro": {}
};

export function siniestrosRdc(state = initialState, action) {
	switch (action.type) {
		case "SINIESTROS_SET_SINIESTROSREP":   
		return {...state,
			"objetoSReparacion": action.objetoSReparacion,
			"sreparacion": action.sreparacion,
			"aviso": action.aviso
		};
	case "SINIESTROS_SET_SINIESTROSREM":  
		function compare(a,b) {
		  if (a.numPoliza > b.numPoliza)
		    return -1;
		  if (a.numPoliza < b.numPoliza)
		    return 1;
		  return 0;
		}
		
		action.sreembolsos.sort(compare);
		return {...state,
			"sreembolsos": action.sreembolsos,
			"originalReembolsos": action.sreembolsos
		};
	case "SINIESTROS_SET_SINIESTROSREMACT":
		return {...state,
			"sreembolsos": action.sreembolsos
		};
	case "SINIESTROS_SET_SELECT_REP":
		return {...state,
			"sinrepSelect": action.select
		};
	case "SINIESTROS_SET_SELECT_REM":
		return {...state,
			"sinremSelect": action.select
		};
	case "SINIESTROS_SET_DETALLE_SINIESTROREP":
		return {...state,
			"detalleSiniestro": action.detalle
		};
	case "SINIESTROS_SET_EVENT":
	case "SEG_SIN_SET_EVENT": 
		return {...state,
			"evento": action.evento
		};
	case "SINIESTROS_SET_DETALLE_SINIESTRO_VALUACION":
		return {
			...state,
			"valuacion": action.valuacion
		}
	case "SINIESTROS_SET_DETALLE_SINIESTRO_REPARACION":
		return {
			...state,
			"reparacion": action.reparacion
		}
	case "SINIESTROS_SET_DETALLE_SINIESTRO_PAGOS":
		return {
			...state, 
			"pagos": action.pagos
		}
	case "SINIESTROS_SET_DETALLE_SINIESTRO_ROBOS":
		return {
			...state,
			"robos": action.robos
		}
	case "SINIESTROS_SET_DETALLE_SINIESTRO_PT":
		return {
			...state,
			"pt": action.pt
		}
	case "SINIESTROS_SET_DETALLE_SINIESTRO_SEG":
		return {
			...state,
			"siniestro": action.siniestro
		};
	default:
		return state;
	}
}



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/reducer.js